import { INotification, INotificationType } from './../../models/notification';
import { FormControl } from '@angular/forms';
import { IContractArrayInput, IContractInput } from 'src/app/models/contract';
import { ILot, IContractLot, IHeaderItem } from 'src/app/models/generic';

export const Inputs: {
  [key: string]: IContractInput[] | IContractArrayInput[];
} = {
  detalhes: [
    {
      label: 'Banco',
      placeholder: 'Nome do banco responsável pelo financiamento',
      controlName: 'FinancialInstitution',
      value: null
    },
    {
      label: 'BPO/Regional',
      placeholder: 'BPO ou regional do contrato',
      controlName: 'Bpo',
      value: null
    },
    {
      label: 'Tipo de Operação',
      placeholder: 'OP/ONP',
      controlName: 'OperationType',
      value: null
    },
    {
      label: 'Produto',
      placeholder: 'Produto',
      controlName: 'Product',
      value: null
    },
    {
      label: 'Consulta',
      placeholder: 'Nº de consulta do contrato',
      controlName: 'QueryNumber',
      value: null
    },
    {
      label: 'Contrato',
      placeholder: 'Número do contrato no banco',
      controlName: 'Number',
      value: null
    },
    {
      label: 'Novo Contrato',
      placeholder: 'Número do novo contrato',
      controlName: '',
      value: null
    },
    {
      label: 'Versão',
      placeholder: 'Versão do contrato no banco',
      controlName: 'Version',
      value: null
    },
    {
      label: 'Status Contrato',
      placeholder: 'Status do contrato no sistema do banco',
      controlName: 'StatusOverride',
      value: null
    },
    {
      label: 'Data do Contrato',
      placeholder: 'Data da produção do contrato no sistema',
      controlName: 'ContractDate',
      value: null,
      type: 'datetime-local'
    },
    {
      label: 'Data da Produção',
      placeholder: 'Data da produção do contrato no sistema',
      controlName: 'ContractDate',
      value: null,
      type: 'datetime-local'
    },
    {
      label: 'Cliente',
      placeholder: 'Nome do cliente que solicitou o financiamento',
      controlName: 'Client',
      value: null
    },
    {
      label: 'CPF/CNPJ Cliente',
      placeholder: 'CPF/CNPJ do cliente que solicitou o financiamento',
      controlName: 'ClientDocument',
      value: null,
      mask: 'CPF_CNPJ'
    },
    {
      label: 'Canal',
      placeholder: 'Canal pelo qual o contrato entrou',
      controlName: 'Chanel',
      value: null
    },
    {
      label: 'Alíquota',
      placeholder: 'Valor da Alíquota',
      controlName: 'Fee',
      value: null
    },
    {
      label: 'Valor Financiamento',
      placeholder: 'Valor de financiamento contratado pelo cliente',
      controlName: 'Amount',
      value: null,
      mask: 'separator.6',
      currency: true
    },
    {
      label: 'Observações',
      placeholder: 'Campo de texto livre',
      controlName: 'Comments',
      value: null,
      custom: true
    },
    {
      label: 'Mensagem de erro',
      placeholder: 'Mensagem quando houver erro',
      controlName: 'MsgError',
      value: null,
      custom: true,
      error: true
    },
  ],
  financiamento: [
    {
      label: 'Status Faturamento',
      placeholder: 'Status do Faturamento',
      controlName: 'BatchStatus',
      value: null
    },
    {
      label: 'NF',
      placeholder: 'Número da NF retornado pelo OMIE',
      controlName: 'Nfe',
      value: null
    },
    {
      label: 'Dt. Faturamento',
      placeholder: 'Data de faturamento no sistema',
      controlName: 'InvoiceDate',
      value: null,
      type: 'datetime-local'
    },
    {
      label: 'VGV',
      placeholder: 'Valor do contrato de financiamento',
      controlName: 'VGC',
      value: null,
      currency: true,
      mask: 'separator.2'
    },
    {
      label: 'Tipo de Faturamento',
      placeholder:
        'Campo para informar se o faturamento foi realizado pelo cliente ou pelo banco',
      controlName: 'ContractType',
      value: null
    },
    {
      label: 'Faturado (%)',
      placeholder: 'Porcentagem do contrato que será faturado',
      controlName: 'ContractAmountPercent',
      value: null
    },
    {
      label: 'Nº do Lote de Faturamento',
      placeholder: 'Número do lote que contém os contratos',
      controlName: 'BatchNumber',
      value: null
    },
    {
      label: 'Valor Faturado',
      placeholder: 'Valor em R$ faturado',
      controlName: 'BatchAmount',
      value: null,
      mask: 'separator.2',
      currency: true
    },
    {
      label: 'Nº do Lote de Repasse',
      placeholder: 'Número do lote que contém os repasses',
      controlName: 'BatchTransferNumber',
      value: null
    }
  ],
  beneficiarioParceiro: [
    {
      label: 'Parceiro',
      placeholder: 'Nome do parceiro gerador do contrato',
      controlName: 'Name',
      value: null
    },
    {
      label: 'CPF/CNPJ do Parceiro',
      placeholder: 'CNPJ do Parceiro',
      controlName: 'Document',
      value: null,
      mask: 'CPF_CNPJ'
    }
  ],
  beneficiarioSubsidiaria: [
    {
      label: 'Subsidiária',
      placeholder: 'Subsidiária do contrato (Credimorar)',
      controlName: 'Name',
      value: null
    },
    {
      label: 'CPF/CNPJ da Subsidiária',
      placeholder: 'CNPJ da Subsidiária',
      controlName: 'Document',
      value: null,
      mask: 'CPF_CNPJ'
    }
  ],
  beneficiario: [
    {
      label: 'CPF/CNPJ do Beneficiário',
      placeholder: 'CNPJ do Beneficiário',
      controlName: 'Document',
      value: null
    },
    {
      label: 'Tipo Beneficiário',
      placeholder: 'Tipo de beneficiário',
      controlName: 'BeneficiaryType',
      value: null
    },
    {
      label: 'Comissão',
      placeholder: 'Valor da comissão',
      controlName: 'Fee',
      value: null,
      // mask: 'percent.2',
      currency: false
    },
    {
      label: 'Valor',
      placeholder: 'Valor',
      controlName: 'Amount',
      value: null,
      mask: 'separator.2',
      currency: true
    },
    {
      label: 'Dt. Prev. Rec',
      placeholder: '',
      controlName: 'EstimatedPaymentDate',
      value: null,
      currency: false,
      type: 'datetime-local'
    },
    {
      label: 'Dt. Rec',
      placeholder: '',
      controlName: 'PaymentDate',
      value: null,
      currency: false,
      type: 'datetime-local'
    }
  ]
};

export const BeneficiarioBaseInputs = {
  inputs: [
    {
      label: 'Nome',
      placeholder: 'Nome do Beneficiário',
      controlName: 'Name',
      value: null
    },
    {
      label: 'CPF/CNPJ do Beneficiário',
      placeholder: 'CNPJ do Beneficiário',
      controlName: 'Document',
      value: null,
      mask: 'CPF_CNPJ'
    },
    {
      label: 'Tipo Beneficiário',
      placeholder: 'Tipo de beneficiário',
      controlName: 'BeneficiaryTypeId',
      value: null,
      select: true
    },
    {
      label: 'Tipo Beneficiário',
      placeholder: 'Tipo de beneficiário',
      controlName: 'BeneficiaryType',
      value: null,
      isHidden: true
    },
    {
      label: 'Comissão',
      placeholder: 'Valor da comissão',
      controlName: 'Fee',
      value: null
    },
    {
      label: 'Valor',
      placeholder: 'Valor',
      controlName: 'Amount',
      value: null,
      mask: 'separator.2',
      currency: true,
      readonly: true
    },
    {
      label: 'Dt. Prev. Rec',
      placeholder: '',
      controlName: 'EstimatedPaymentDate',
      value: null,
      currency: false,
      type: 'datetime-local',
      readonly: true
    },
    {
      label: 'Dt. Rec',
      placeholder: '',
      controlName: 'PaymentDate',
      value: null,
      currency: false,
      type: 'datetime-local',
      readonly: true
    }
  ]
};

//esse cara aqui usa no card
export const beneficiarioInputInfos: {
  [key: string]: {
    label: string;
    placeholder: string;
    mask?: string;
    currency?: boolean;
    type?: string;
  };
} = {
  Document: {
    label: 'CPF/CNPJ do Beneficiário',
    placeholder: 'CPF/CNPJ do Beneficiário',
    mask: 'CPF_CNPJ'
  },
  BeneficiaryType: {
    label: 'Tipo de Beneficiário',
    placeholder: 'Tipo de beneficiário'
  },
  Fee: {
    label: 'Comissão',
    placeholder: 'Valor da comissão'
  },
  Amount: {
    label: 'Valor',
    placeholder: 'Valor',
    mask: 'separator.2',
    currency: true
  },
  EstimatedPaymentDate: {
    label: 'Dt. Prev. Rec',
    placeholder: '',
    type: 'datetime-local'
  },
  PaymentDate: {
    label: 'Dt. Rec',
    placeholder: '',
    type: 'datetime-local'
  }
};

export const MainTitle = 'Esteira de Apuração';
export const ApproveTitle = 'Aprovação de edição de proposta';
export const DetailsTitle = 'Detalhes do Contrato';
export const TransferTitle = 'Repasse de Comissão';
export const ContractTitle = 'Faturamento dos Contratos';

export const lotsList: ILot[] = [
  {
    Active: true,
    AmountTotal: 1,
    Bank: 'Santander',
    BatchId: 1,
    BatchNumber: '5161531390921581594',
    BatchStatus: '',
    Calculations: 'abc',
    Channel: 'teste',
    Checked: false,
    CreateDate: '2022-09-05T16:47:10.429726',
    EstimatedPaymentDate: ' 2022-09-05T16:47:10.429726',
    Integrated: false,
    InvoiceDate: '2022-09-05T16:47:10.429726',
    IsInvoiced: false,
    NumberOfContracts: 2,
    OrderDate: '2022-09-05T16:47:10.429726',
    OrderNumber: '123',
    Partner: 'Brasil',
    PaymentDate: '2022-09-05T16:47:10.429726',
    StatusOfOnlending: 'teste',
    InvoiceNumber: '123',
    NumberCurrentBatch: '1',
    ReceiptDate: '2022-09-05T16:47:10.429726',
    Contracts: [
      {
        ContractId: '123123',
        Number: '012',
        QueryNumber: '012',
        BeneficiaryName: 'teste',
        Status: 'aprovado',
        Amount: 2,
        Chanel: 'teste',
        FinancialInstitution: 'Banco',
        ContractType: 'tipo 1',
        BeneficiaryType: 'tipo 1',
        BeneficiaryFee: 2,
        CreateDate: '',
        Active: true
      },
      {
        ContractId: '123123',
        Number: '345',
        QueryNumber: '345',
        BeneficiaryName: 'teste',
        Status: 'aprovado',
        Amount: 2,
        Chanel: 'teste',
        FinancialInstitution: 'Banco',
        ContractType: 'tipo 1',
        BeneficiaryType: 'tipo 1',
        BeneficiaryFee: 2,
        CreateDate: '',
        Active: true
      }
    ]
  },
  {
    Active: true,
    AmountTotal: 1,
    Bank: 'Santander',
    BatchId: 11,
    BatchNumber: '5161531390921581594',
    BatchStatus: '',
    Calculations: 'abc',
    Channel: 'teste',
    Checked: false,
    CreateDate: '2022-09-05T16:47:10.429726',
    EstimatedPaymentDate: ' 2022-09-05T16:47:10.429726',
    Integrated: false,
    InvoiceDate: '2022-09-05T16:47:10.429726',
    IsInvoiced: false,
    NumberOfContracts: 2,
    OrderDate: '2022-09-05T16:47:10.429726',
    OrderNumber: '123',
    Partner: 'Brasil',
    PaymentDate: '2022-09-05T16:47:10.429726',
    StatusOfOnlending: 'teste',
    InvoiceNumber: '123',
    NumberCurrentBatch: '1',
    ReceiptDate: '2022-09-05T16:47:10.429726',
    Contracts: [
      {
        ContractId: '123123',
        Number: '012',
        QueryNumber: '012',
        BeneficiaryName: 'teste',
        Status: 'aprovado',
        Amount: 2,
        Chanel: 'teste',
        FinancialInstitution: 'Banco',
        ContractType: 'tipo 1',
        BeneficiaryType: 'tipo 1',
        BeneficiaryFee: 2,
        CreateDate: '',
        Active: true
      },
      {
        ContractId: '123123',
        Number: '345',
        QueryNumber: '345',
        BeneficiaryName: 'teste',
        Status: 'aprovado',
        Amount: 2,
        Chanel: 'teste',
        FinancialInstitution: 'Banco',
        ContractType: 'tipo 1',
        BeneficiaryType: 'tipo 1',
        BeneficiaryFee: 2,
        CreateDate: '',
        Active: true
      }
    ]
  },

  {
    Active: true,
    AmountTotal: 1,
    Bank: 'Santander',
    BatchId: 13,
    BatchNumber: '5161531390921581594',
    BatchStatus: '',
    Calculations: 'abc',
    Channel: 'teste',
    Checked: false,
    CreateDate: '2022-09-05T16:47:10.429726',
    EstimatedPaymentDate: ' 2022-09-05T16:47:10.429726',
    Integrated: false,
    InvoiceDate: '2022-09-05T16:47:10.429726',
    IsInvoiced: false,
    NumberOfContracts: 2,
    OrderDate: '2022-09-05T16:47:10.429726',
    OrderNumber: '123',
    Partner: 'Brasil',
    PaymentDate: '2022-09-05T16:47:10.429726',
    StatusOfOnlending: 'teste',
    InvoiceNumber: '123',
    NumberCurrentBatch: '1',
    ReceiptDate: '2022-09-05T16:47:10.429726',
    Contracts: [
      {
        ContractId: '123123',
        Number: '012',
        QueryNumber: '012',
        BeneficiaryName: 'teste',
        Status: 'aprovado',
        Amount: 2,
        Chanel: 'teste',
        FinancialInstitution: 'Banco',
        ContractType: 'tipo 1',
        BeneficiaryType: 'tipo 1',
        BeneficiaryFee: 2,
        CreateDate: '',
        Active: true
      },
      {
        ContractId: '123123',
        Number: '345',
        QueryNumber: '345',
        BeneficiaryName: 'teste',
        Status: 'aprovado',
        Amount: 2,
        Chanel: 'teste',
        FinancialInstitution: 'Banco',
        ContractType: 'tipo 1',
        BeneficiaryType: 'tipo 1',
        BeneficiaryFee: 2,
        CreateDate: '',
        Active: true
      }
    ]
  },

  {
    Active: true,
    AmountTotal: 14,
    Bank: 'Santander',
    Channel: 'teste',
    CreateDate: '2022-09-05T16:47:10.429726',
    BatchId: 14,
    BatchNumber: '12121215',
    BatchStatus: '',
    NumberOfContracts: 2,
    Partner: 'Brasil',
    Checked: false,
    Contracts: [
      {
        ContractId: '123123',
        Number: '678',
        QueryNumber: '678',
        BeneficiaryName: 'teste',
        Status: 'aprovado',
        Amount: 2,
        Chanel: 'teste',
        FinancialInstitution: 'Banco',
        ContractType: 'tipo 1',
        BeneficiaryType: 'tipo 1',
        BeneficiaryFee: 2,
        CreateDate: '',
        Active: true
      },
      {
        ContractId: '123123',
        Number: '901',
        QueryNumber: '901',
        BeneficiaryName: 'teste',
        Status: 'aprovado',
        Amount: 2,
        Chanel: 'teste',
        FinancialInstitution: 'Banco',
        ContractType: 'tipo 1',
        BeneficiaryType: 'tipo 1',
        BeneficiaryFee: 2,
        CreateDate: '',
        Active: true
      }
    ]
  }
];

export const cancelContractList: INotification[] = [
  {
    NotificationType: 'CancelContract',
    UserId: 'any',
    ContractId: '2bff6e2b-0bf0-44c6-aa0d-33f1bd635175',
    ContractNumber: '121262'
  },
  {
    NotificationType: 'CancelContract',
    UserId: 'any',
    ContractId: '1a5ff00a-0341-4ba4-9afc-5091e674fa6b',
    ContractNumber: '303041'
  },
  {
    NotificationType: 'CancelContract',
    UserId: 'any',
    ContractId: '47eb28e5-4398-41e3-98db-52243e0278f0',
    ContractNumber: '303040'
  },
  {
    NotificationType: 'CancelContract',
    UserId: 'any',
    ContractId: 'c37a630c-bacb-4674-b5b2-6a7345312f38',
    ContractNumber: '202250'
  }
];

export const cancelCompanyList: INotification[] = [
  {
    NotificationType: 'CancelContract',
    UserId: 'any',
    ContractId: '8e9a7bd9-c3f4-4b70-a1da-2301706fa73f',
    ContractNumber: '121250'
  },
  {
    NotificationType: 'CancelContract',
    UserId: 'any',
    ContractId: '2bff6e2b-0bf0-44c6-aa0d-33f1bd635175',
    ContractNumber: '121262'
  },
  {
    NotificationType: 'CancelContract',
    UserId: 'any',
    ContractId: '1a5ff00a-0341-4ba4-9afc-5091e674fa6b',
    ContractNumber: '303041'
  }
];

export const notificationMock: INotificationType[] = [
  {
    Notification: 'CancelCompany',
    Count: 0
  },
  {
    Notification: 'CancelContract',
    Count: 4
  }
];

export const InvoiceContractsHeaderItems: IHeaderItem[] = [
  { label: 'N° Contrato', flexSize: 1 },
  { label: 'N° Consulta', flexSize: 1 },
  { label: 'Banco', flexSize: 1 },
  { label: 'Valor Financiamento', flexSize: 1 },
  { label: 'Valor Comissão', flexSize: 1 },
  { label: 'Tipo de Operação', flexSize: 1 },
  { label: 'Cliente', flexSize: 1 },
  { label: 'CPF/CNPJ Cliente', flexSize: 1 },
  { label: 'Comissão', flexSize: 1 },
  { label: 'Dt.Produção', flexSize: 1 },
  { label: 'Status', flexSize: 1 }
];

export const TransferContractsHeaderItems: IHeaderItem[] = [
  { label: 'N° Contrato', flexSize: 1 },
  { label: 'N° Consulta', flexSize: 1 },
  { label: 'Banco', flexSize: 1 },
  { label: 'Valor Financiamento', flexSize: 1 },
  { label: 'Valor Repasse', flexSize: 1 },
  { label: 'Operação', flexSize: 1 },
  { label: 'Cliente', flexSize: 1 },
  { label: 'CPF/CNPJ Cliente', flexSize: 1 },
  { label: 'Canal', flexSize: 1 },
  { label: 'Dt. Produção', flexSize: 1 },
  { label: 'Lote', flexSize: 1 },
  { label: 'Status', flexSize: 1 }
];

export const StoreConfigHeaderItems: IHeaderItem[] = [
  { label: 'Subsidiária', flexSize: 1, name: 'Subsidiary', isOrder: true, orderValue: 0 },
  { label: 'Banco', flexSize: 1, name: 'Bank', isOrder: true, orderValue: 0 },
  { label: 'Loja', flexSize: 1, name: 'StoreConfigId', isOrder: true, orderValue: 0 },
  { label: 'Produto', flexSize: 1, name: 'Product', isOrder: true, orderValue: 0 },
  { label: 'Comissão %', flexSize: 1, name: 'Commission', isOrder: true, orderValue: 0 },
  { label: 'Centro de Custo', flexSize: 1, name: 'CostCenter', isOrder: true, orderValue: 0 },
  { label: 'Dt. Vig. Inicio', flexSize: 1, name: 'StartDate', isOrder: true, orderValue: 0 },
  { label: 'Dt. Vig. Final', flexSize: 1, name: 'FinishDate', isOrder: true, orderValue: 0 },
  { label: 'Tipo Beneficiário', flexSize: 1, name: 'BeneficiaryType', isOrder: true, orderValue: 0 },
  { label: 'Tipo Venda', flexSize: 1, name: 'SaleType', isOrder: true, orderValue: 0 }
];

export const ReverseConfigDefaultHeaderItems: IHeaderItem[] = [
  { label: 'Banco', flexSize: 1 },
  { label: 'Canal', flexSize: 1 },
  { label: 'Status Contrato', flexSize: 1 },
  { label: 'Prazo para Estorno (Dias)', flexSize: 1 },
  { label: 'Tipo de Estorno', flexSize: 1 },
  { label: 'Valor de Estorno', flexSize: 1 }
];

export const ReverseConfigDocumentHeaderItems: IHeaderItem[] = [
  { label: 'CNPJ Beneficiário', flexSize: 1 },
  { label: 'Status Contrato', flexSize: 1 },
  { label: 'Prazo para Estorno (Dias)', flexSize: 1 },
  { label: 'Tipo de Estorno', flexSize: 1 },
  { label: 'Valor de Estorno', flexSize: 1 }
];

export const ManualBatchContractsHeaderItems: IHeaderItem[] = [
  {
    name: 'FinancialInstitution',
    label: 'Banco',
    flexSize: 2,
    isOrder: true,
    orderValue: 0
  },
  {
    name: 'Number',
    label: 'Contrato',
    flexSize: 2,
    isOrder: true,
    orderValue: 0
  },
  {
    name: 'BeneficiaryName',
    label: 'Beneficiário',
    flexSize: 4,
    isOrder: true,
    orderValue: 0
  },
  {
    name: 'Client',
    label: 'Cliente',
    flexSize: 4,
    isOrder: true,
    orderValue: 0
  },
  {
    name: 'Amount',
    label: 'Repasse',
    flexSize: 3,
    isOrder: true,
    orderValue: 0
  },
  {
    name: 'Status',
    label: 'Status',
    flexSize: 3,
    isOrder: true,
    orderValue: 0
  },
  {
    name: 'ProductionDate',
    label: 'Faturamento',
    flexSize: 4,
    isOrder: true,
    orderValue: 0
  }
];

export const ContractList = [
  {
    ContractId: '123123',
    Number: '012',
    BeneficiaryName: 'teste',
    Status: 'aprovado',
    Amount: 2,
    Chanel: 'teste',
    FinancialInstitution: 'Banco',
    ContractType: 'tipo 1',
    BeneficiaryType: 'tipo 1',
    BeneficiaryFee: 2,
    CreateDate: '',
    Active: true
  },
  {
    ContractId: '123123',
    Number: '345',
    BeneficiaryName: 'teste',
    Status: 'aprovado',
    Amount: 2,
    Chanel: 'teste',
    FinancialInstitution: 'Banco',
    ContractType: 'tipo 1',
    BeneficiaryType: 'tipo 1',
    BeneficiaryFee: 2,
    CreateDate: '',
    Active: true
  }
];

export const ContracListManualBatch: IContractLot[] = [
  {
    ContractId: '8d4ba0be-5e6c-4efc-a02f-89d88076bd43',
    BeneficiaryName: 'V O S FARIA LTDA',
    Status: 'Elaborado',
    Amount: 300000,
    Chanel: 'Credimorar',
    FinancialInstitution: 'bradesco',
    ContractType: '',
    BeneficiaryType: 'Parceiro',
    BeneficiaryFee: 1,
    CreateDate: '2022-11-17T22:52:32.655284',
    Active: true,
    Number: '9118295',
    QueryNumber: '9118295',
    ProductionDate: '2022-10-31T00:00:00',
    OperationType: 'ONP',
    Client: 'Fabio Neiva Ribeiro',
    ClientDocument: '344.289.478-60',
    TransferAmount: 0,
    InvoiceBatchNumber: '',
    InvoiceBatchPaid: false,
    InvoiceBatchStatus: ''
  },
  {
    ContractId: 'c6bebfd0-f04b-4b0c-a193-62aa75f99341',
    BeneficiaryName: 'V O S FARIA LTDA',
    Status: 'Elaborado',
    Amount: 300000,
    Chanel: 'Credimorar',
    FinancialInstitution: 'bradesco',
    ContractType: '',
    BeneficiaryType: 'Parceiro',
    BeneficiaryFee: 1,
    CreateDate: '2022-11-17T22:52:36.845332',
    Active: true,
    Number: '9117246',
    QueryNumber: '9117246',
    ProductionDate: '2022-10-18T00:00:00',
    OperationType: 'ONP',
    Client: 'Jaqueline Rigotti Kubiszeski Guarnieri',
    ClientDocument: '021.959.451-17',
    TransferAmount: 0,
    InvoiceBatchNumber: '',
    InvoiceBatchPaid: false,
    InvoiceBatchStatus: ''
  },
  {
    ContractId: 'f0e84f0a-887d-407a-9bb4-d87952d79702',
    BeneficiaryName: 'SLP SERVIAOS E NEGACIOS LTDA',
    Status: 'Elaborado',
    Amount: 300000,
    Chanel: 'Credimorar',
    FinancialInstitution: 'bradesco',
    ContractType: '',
    BeneficiaryType: 'Parceiro',
    BeneficiaryFee: 1.8,
    CreateDate: '2022-11-17T22:52:32.917854',
    Active: true,
    Number: '9118395',
    QueryNumber: '9118395',
    ProductionDate: '2022-10-31T00:00:00',
    OperationType: 'ONP',
    Client: 'Felipe Domingues Petermann',
    ClientDocument: '368.227.098-19',
    TransferAmount: 0,
    InvoiceBatchNumber: '',
    InvoiceBatchPaid: false,
    InvoiceBatchStatus: ''
  },
  {
    ContractId: '99128d5e-bace-4697-8ac4-7f1c195cca7c',
    BeneficiaryName: 'V O S FARIA LTDA',
    Status: 'Elaborado',
    Amount: 432000,
    Chanel: 'Credimorar',
    FinancialInstitution: 'bradesco',
    ContractType: '',
    BeneficiaryType: 'Parceiro',
    BeneficiaryFee: 1,
    CreateDate: '2022-11-17T22:52:25.43974',
    Active: true,
    Number: '9118057',
    QueryNumber: '9118057',
    ProductionDate: '2022-10-26T00:00:00',
    OperationType: 'ONP',
    Client: 'Anderson Avila Marmentini',
    ClientDocument: '875.360.722-87',
    TransferAmount: 0,
    InvoiceBatchNumber: '',
    InvoiceBatchPaid: false,
    InvoiceBatchStatus: ''
  },
  {
    ContractId: '99128d5e-bace-4697-8ac4-7f1c195cca7c',
    BeneficiaryName: 'V O S FARIA LTDA',
    Status: 'Elaborado',
    Amount: 432000,
    Chanel: 'Credimorar',
    FinancialInstitution: 'bradesco',
    ContractType: '',
    BeneficiaryType: 'Parceiro',
    BeneficiaryFee: 1,
    CreateDate: '2022-11-17T22:52:25.43974',
    Active: true,
    Number: '9118057',
    QueryNumber: '9118057',
    ProductionDate: '2022-10-26T00:00:00',
    OperationType: 'ONP',
    Client: 'Anderson Avila Marmentini',
    ClientDocument: '875.360.722-87',
    TransferAmount: 0,
    InvoiceBatchNumber: '',
    InvoiceBatchPaid: false,
    InvoiceBatchStatus: ''
  },
  {
    ContractId: '99128d5e-bace-4697-8ac4-7f1c195cca7c',
    BeneficiaryName: 'V O S FARIA LTDA',
    Status: 'Elaborado',
    Amount: 432000,
    Chanel: 'Credimorar',
    FinancialInstitution: 'bradesco',
    ContractType: '',
    BeneficiaryType: 'Parceiro',
    BeneficiaryFee: 1,
    CreateDate: '2022-11-17T22:52:25.43974',
    Active: true,
    Number: '9118057',
    QueryNumber: '9118057',
    ProductionDate: '2022-10-26T00:00:00',
    OperationType: 'ONP',
    Client: 'Anderson Avila Marmentini',
    ClientDocument: '875.360.722-87',
    TransferAmount: 0,
    InvoiceBatchNumber: '',
    InvoiceBatchPaid: false,
    InvoiceBatchStatus: ''
  },
  {
    ContractId: '99128d5e-bace-4697-8ac4-7f1c195cca7c',
    BeneficiaryName: 'V O S FARIA LTDA',
    Status: 'Elaborado',
    Amount: 432000,
    Chanel: 'Credimorar',
    FinancialInstitution: 'bradesco',
    ContractType: '',
    BeneficiaryType: 'Parceiro',
    BeneficiaryFee: 1,
    CreateDate: '2022-11-17T22:52:25.43974',
    Active: true,
    Number: '9118057',
    QueryNumber: '9118057',
    ProductionDate: '2022-10-26T00:00:00',
    OperationType: 'ONP',
    Client: 'Anderson Avila Marmentini',
    ClientDocument: '875.360.722-87',
    TransferAmount: 0,
    InvoiceBatchNumber: '',
    InvoiceBatchPaid: false,
    InvoiceBatchStatus: ''
  },
  {
    ContractId: '99128d5e-bace-4697-8ac4-7f1c195cca7c',
    BeneficiaryName: 'V O S FARIA LTDA',
    Status: 'Elaborado',
    Amount: 432000,
    Chanel: 'Credimorar',
    FinancialInstitution: 'bradesco',
    ContractType: '',
    BeneficiaryType: 'Parceiro',
    BeneficiaryFee: 1,
    CreateDate: '2022-11-17T22:52:25.43974',
    Active: true,
    Number: '9118057',
    QueryNumber: '9118057',
    ProductionDate: '2022-10-26T00:00:00',
    OperationType: 'ONP',
    Client: 'Anderson Avila Marmentini',
    ClientDocument: '875.360.722-87',
    TransferAmount: 0,
    InvoiceBatchNumber: '',
    InvoiceBatchPaid: false,
    InvoiceBatchStatus: ''
  }
];
